/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React, { useState } from 'react'
import { Button, Flex } from '@chakra-ui/react'
import FilterAndSortBarWithActions from '../FilterAndSortBarWithActions'
import { SELECT_ALL, UNSELECT_ALL } from '@/configs/strings/listings'

const FilterAndSortBarWithSelectAll = ({
  className = '',
  currentValues,
  filterOptions,
  onFilterResults,
  onReset,
  searchResultsKeyData,
  searchResultsKeyLabel,
  searchResultsKeyValue,
  selectAll,
  sortOptions,
  toggleSelectAll
}) => {
  const [isSelectAll, setIsSelectAll] = useState(false)
  const handleToggleSelectAll = () => {
    setIsSelectAll((prevValue) => !prevValue)
    toggleSelectAll && toggleSelectAll()
  }

  return (
    <Flex
      as="section"
      className={`${className}`}
      justifyContent={{
        sm: 'space-between'
      }}
      gap={{
        base: 5,
        md: 0
      }}
      direction={{ base: 'column', md: 'row' }}
    >
      { filterOptions &&
        <FilterAndSortBarWithActions
          currentValues={currentValues}
          filterOptions={filterOptions}
          onFilterResults={onFilterResults}
          onReset={onReset}
          searchResultsKeyData={searchResultsKeyData}
          searchResultsKeyLabel={searchResultsKeyLabel}
          searchResultsKeyValue={searchResultsKeyValue}
          sortOptions={sortOptions}
        />
      }
      { selectAll &&
        <Button
          onClick={handleToggleSelectAll}
        >
          { isSelectAll ? UNSELECT_ALL : SELECT_ALL }
        </Button>
      }
    </Flex>
  )
}

export default FilterAndSortBarWithSelectAll
